import {
  Button,
  Card,
  Flex,
  Heading,
  Modal,
  Text,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
} from '@chakra-ui/react';
import { useResources } from 'datx-jsonapi-react';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { IToastType } from '@/enums/ToastType';
import useSession from '@/hooks/useSession';
import { useStores } from '@/hooks/useStores';
import { useToast } from '@/hooks/useToast';
import { queryProfilePlaylists } from '@/queries/profile-playlists';
import { queryThinProfilesByUserId } from '@/queries/thin-profiles';
import { ThinProfile } from '@/resources/ThinProfile';

interface IDeletePlaylistModalProps {
  onClose: () => void;
  playlistId: string;
}

export const DeletePlaylistModal: FC<IDeletePlaylistModalProps> = ({ onClose, playlistId }) => {
  const { t } = useTranslation();
  const { user } = useSession();
  const { data } = useResources<ThinProfile>(queryThinProfilesByUserId(user?.id));
  const { store } = useStores();
  const toast = useToast();

  const { mutate } = useResources(queryProfilePlaylists(data?.[0]?.id));

  const handleDelete = async () => {
    try {
      await store.request(`${ThinProfile.type}/${data?.[0]?.id}/playlists/${playlistId}`, 'DELETE');

      mutate();
      onClose();

      toast({
        status: IToastType.SUCCESS,
        title: t('newLecture.bookmarkModal.deleteModal.successfulDeleteNotification'),
      });
    } catch (response) {
      toast({ status: IToastType.ERROR, title: response.error[0].detail });
    }
  };

  return (
    <Modal isOpen={Boolean(playlistId)} onClose={onClose} isCentered>
      <ModalOverlay />
      <ModalContent>
        <Card p="6">
          <Heading fontSize="xl" mb="4">
            {t('newLecture.bookmarkModal.deleteModal.heading')}
          </Heading>
          <Text mb="6">{t('newLecture.bookmarkModal.deleteModal.description')}</Text>
          <Flex>
            <Button
              textTransform="lowercase"
              onClick={handleDelete}
              size="sm"
              bgColor="black"
              _hover={{ bgColor: 'black' }}
              variant="solid"
            >
              {t('profilePage.formAction.delete')}
            </Button>
            <Button textTransform="lowercase" size="sm" color="black" onClick={onClose} variant="ghost">
              {t('profilePage.formAction.cancel')}
            </Button>
          </Flex>
        </Card>
        <ModalCloseButton color="white" />
      </ModalContent>
    </Modal>
  );
};
